import Image from "next/legacy/image";

import NoTextNavBackground from "../components/common/NoTextNavBackground";
import ClubGroupCard from "../components/elements/club/ClubGroupCard";
import HeroSlider from "../components/common/slider/HeroSlider";
import { blurDataURL } from "../utils/constants/images";
import {
  CONTACT_US_URL,
  FANS_URL,
  KOTOKO_HISTORY_URL,
  LEGEND_LIST_URL,
  PEOPLE_LIST_URL,
  TROPHIES_URL,
} from "../utils/constants/websiteUrls";
import { customStaticSeoConfig } from "../utils/helpers/helpers";

import {
  stadium1,
  aj2,
  history1,
  legends1,
  loginPageBackgroundImageUrl,
  history2,
  club1,
  club7,
  fans3,
  fans1,
  stadium2,
} from "../utils/constants/images";

const Club = () => {
  const images = [
    stadium1,
    aj2,
    history1,
    legends1,
    loginPageBackgroundImageUrl,
    history2,
    club1,
    club7,
    fans3,
  ];

  const clubGroupCard = [
    { id: 1, title: "History", imgSrc: history1, href: KOTOKO_HISTORY_URL },
    {
      id: 2,
      title: "Honors",
      imgSrc: loginPageBackgroundImageUrl,
      href: TROPHIES_URL,
    },
    { id: 3, title: "Legends", imgSrc: legends1, href: LEGEND_LIST_URL },
    { id: 4, title: "People", imgSrc: club1, href: PEOPLE_LIST_URL },
    { id: 5, title: "Fans", imgSrc: fans3, href: FANS_URL },
    { id: 6, title: "Club Contacts", imgSrc: fans1, href: CONTACT_US_URL },
  ];

  const title = "Club Information";
  const seoTitle = "Asante Kotoko Club Information";

  return (
    <>
      {customStaticSeoConfig(seoTitle)}

      <NoTextNavBackground />

      <HeroSlider title={title} gallery={images} showScrollToRead={true} />

      <div className="max-w-2xl mx-auto mb-10 px-6 md:max-w-3xl lg:max-w-5xl xl:max-w-5xl 2xl:max-w-7xl py-10">
        <ClubGroupCard clubGroupCard={clubGroupCard} />

        <div>
          <h2 className="text-lg font-extrabold tracking-tight text-gray-900 border-b-2 pt-12">
            Facilities
          </h2>
          <section className="text-gray-100">
            <div className="container mx-auto space-y-12">
              <div className="flex flex-col overflow-hidden rounded-md shadow-sm lg:flex-row">
                <Image
                  src={aj2}
                  alt="Thumbnail"
                  width="569px"
                  height="320px"
                  objectFit="cover"
                  placeholder="blur"
                  blurDataURL={blurDataURL}
                  quality={100}
                />

                <div className="flex flex-col justify-center flex-1 p-6 bg-gray-900">
                  <span className="text-xs uppercase text-gray-400">
                    {"The training base of the porcupine warriors"}
                  </span>
                  <h3 className="text-2xl sm:text-3xl font-bold">
                    {"Adako Jachie Training Complex"}
                  </h3>
                  <p className="my-6 text-gray-400">
                    {
                      "The Asante Kotoko Men, Women and Academy teams train and play friendly games here."
                    }
                  </p>
                </div>
              </div>
              <div className="flex flex-col overflow-hidden rounded-md shadow-sm lg:flex-row-reverse">
                <Image
                  src={stadium2}
                  alt="Thumbnail"
                  width="569px"
                  height="320px"
                  objectFit="cover"
                  placeholder="blur"
                  blurDataURL={blurDataURL}
                  quality={100}
                />
                <div className="flex flex-col justify-center flex-1 p-6 bg-gray-900">
                  <span className="text-xs uppercase text-gray-400">
                    {"The venue for home games"}
                  </span>
                  <h3 className="text-2xl sm:text-3xl font-bold">
                    {"Baba Yara Sports Stadium"}
                  </h3>
                  <p className="my-6 text-gray-400">
                    {
                      "The venue where we play all our home games. Baba Yara has a seating capacity of 40,528."
                    }
                  </p>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </>
  );
};

export default Club;
